<template >
    <nav class="hidden">
        <ul>
            <li>
                <router-link :to="{path: '/'}">
                    الرئيسيه
                </router-link>
            </li>
            <li>
                <router-link :to="{name:'products_all'}" >
                    المنتجات
                </router-link>
            </li>
            <li>
                <router-link :to="{name:'size_instructions'}" >
                    دليل المقاسات
                </router-link>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    name: 'NavComponent'
}
</script>
<style scoped>
    ul {
        list-style: none;
    }
    ul li {
        display: inline-block;
        margin-left: 1rem;
    }
    ul li a {
        all:unset;
        width: 100%;
        padding: 0.5rem;
        text-align: center;
        cursor: pointer;
        font-weight: bold;
    }
</style>